import React, {useState} from "../../../../../__snowpack__/pkg/react.js";
import {Button, Modal, Form, Input as AntdInput, Row, Col, Table, Typography, Descriptions} from "../../../../../__snowpack__/pkg/antd.js";
import {DeleteOutlined} from "../../../../../__snowpack__/pkg/@ant-design/icons.js";
import {IconError} from "../../../../../__snowpack__/pkg/@genieui-react/icon.js";
import {useIntlTyped} from "../../../../lib/useIntlTyped.js";
import {localeMessage} from "../../i18n.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
import {eventLogger} from "../../../../lib/eventLogger.js";
import {TableForm} from "./TableForm.js";
import {MainContent} from "./MainContent.js";
import {PopoverImg} from "../../../../components/PopoverImg/index.js";
export const AddProductButtonAndModal = (props) => {
  const {TextArea} = AntdInput;
  const {Column} = Table;
  const {formatMessage} = useIntlTyped(localeMessage);
  const {
    form: addOrderForm,
    disabled,
    addToList,
    onDeleteProduct,
    isThirdPartyWarehouse,
    selectedSkuList,
    setSelectedSkuList
  } = props;
  const [searchForm] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const validTableData = tableData.filter((item) => "" + item.result === "true");
  const [searchFormData, setSearchFormData] = useState(void 0);
  const handleCancel = () => {
    setVisible(false);
    searchForm.resetFields();
    setTableData([]);
    setCurrentPage(1);
    addToList(selectedSkuList);
  };
  const handleAddToList = () => {
    addToList(selectedSkuList);
    handleCancel();
  };
  const [currentPage, setCurrentPage] = useState(1);
  const handleClearAll = () => {
    Modal.confirm({
      title: formatMessage({id: "sureToDelete"}),
      content: "",
      cancelText: formatMessage({id: "cancel"}),
      okText: formatMessage({id: "confirm"}),
      okButtonProps: {danger: true},
      icon: /* @__PURE__ */ React.createElement(IconError, {
        width: "20px",
        height: "20px",
        className: "anticon"
      }),
      onOk: async () => {
        onDeleteProduct(selectedSkuList);
        setSelectedSkuList([]);
      }
    });
  };
  const handleDeleteSelected = (record) => {
    onDeleteProduct([record]);
    setSelectedSkuList(selectedSkuList.filter((item) => {
      return item.shelfInventoryId !== record.shelfInventoryId;
    }));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: () => {
      setVisible(true);
      eventLogger.push({
        action: "ClickMassAdd",
        location: "CreateInboundList"
      });
    },
    disabled
  }, formatMessage({id: "addProduct"})), /* @__PURE__ */ React.createElement(Modal, {
    visible,
    destroyOnClose: true,
    maskClosable: false,
    title: formatMessage({id: "addProduct"}),
    width: "84%",
    style: {top: 10},
    onCancel: handleCancel,
    footer: [
      /* @__PURE__ */ React.createElement(Button, {
        type: "primary",
        key: "analyze",
        onClick: handleAddToList
      }, formatMessage({id: "submit"}))
    ]
  }, /* @__PURE__ */ React.createElement(ModalWrapper, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: 24,
    lg: 18
  }, /* @__PURE__ */ React.createElement(Descriptions, null, /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: formatMessage({id: "warehouseCode"})
  }, props.selectedWarehouse?.code || "-"), /* @__PURE__ */ React.createElement(Descriptions.Item, {
    label: formatMessage({id: "warehouseName2"})
  }, props.selectedWarehouse?.name || "-")), /* @__PURE__ */ React.createElement(TableForm, {
    form: searchForm,
    orderType: props.orderType,
    selectedWarehouseId: addOrderForm.getFieldValue("warehouseId") || "",
    selectedWarehouse: props.selectedWarehouse,
    setFormData: (formData, shouldTrack = true) => {
      setSearchFormData({
        ...searchFormData,
        ...formData,
        ...props.orderType === "OUTBOUND" ? {needCheckCounting: true} : {}
      });
      if (shouldTrack) {
        eventLogger.push({
          action: "ClickSearch",
          location: "InboundManagement",
          actionExtra: {
            WarehouseName: formData.warehouseId ? "True" : "False",
            MasterSku: formData.searchInboundOrderType === "INVENTORY_SKU" && formData.filter ? "True" : "False",
            DocumentStatus: formData.status || "",
            CreateTime: formData.createTimeFrom ? "True" : "False"
          }
        });
      }
    }
  }), /* @__PURE__ */ React.createElement(MainContent, {
    form: searchForm,
    orderType: props.orderType,
    search: searchFormData,
    setSearch: setSearchFormData,
    selectedSkuList,
    selectedWarehouse: props.selectedWarehouse,
    onSelectSku: (data) => {
      if (!data.image && Array.isArray(data.variationImages) && data.variationImages.length) {
        data.image = data.variationImages?.[0] || "";
      }
      setSelectedSkuList([...selectedSkuList, data]);
    }
  })), /* @__PURE__ */ React.createElement(Col, {
    span: 24,
    lg: 6,
    style: {padding: "16px 0 0 16px"}
  }, /* @__PURE__ */ React.createElement("div", {
    style: {
      paddingTop: 8,
      paddingBottom: 36
    }
  }, /* @__PURE__ */ React.createElement("span", {
    style: {display: "inline-block", padding: "8px 0"}
  }, formatMessage({id: "quantityAdded"}), ": ", selectedSkuList.length), /* @__PURE__ */ React.createElement(Button, {
    key: "cancel",
    onClick: handleClearAll,
    style: {position: "absolute", right: 0}
  }, formatMessage({id: "emptySelected"}))), selectedSkuList && selectedSkuList.length > 0 && /* @__PURE__ */ React.createElement("div", {
    style: {
      maxHeight: "calc(100vh - 284px)",
      overflow: "auto",
      padding: 16,
      border: "1px solid #dfe3e8"
    }
  }, selectedSkuList.map((item) => {
    return /* @__PURE__ */ React.createElement("div", {
      className: "product-wrapper",
      key: item.masterVariationId + "||" + (item.shelfInventoryId || ""),
      style: {paddingRight: 12, paddingBottom: 8}
    }, /* @__PURE__ */ React.createElement("div", {
      className: "product-content",
      style: {
        display: "inline-block",
        width: "calc(100% - 30px)"
      }
    }, /* @__PURE__ */ React.createElement("div", {
      className: "product-img"
    }, /* @__PURE__ */ React.createElement(PopoverImg, {
      avatarSize: 64,
      previewImage: item.variationImages?.[0] || ""
    })), /* @__PURE__ */ React.createElement("div", {
      className: "product-info"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "product-info-name"
    }, /* @__PURE__ */ React.createElement(Typography.Paragraph, {
      ellipsis: {
        rows: 1,
        tooltip: item.inventoryName || item.name
      },
      style: {marginBottom: 0}
    }, item.inventoryName || item.name)), /* @__PURE__ */ React.createElement("div", {
      className: "product-info-variation"
    }, /* @__PURE__ */ React.createElement(Typography.Paragraph, {
      ellipsis: {
        rows: 1,
        tooltip: item.inventorySku || item.sku
      },
      style: {marginBottom: 0}
    }, item.inventorySku || item.sku)))), /* @__PURE__ */ React.createElement(DeleteOutlined, {
      style: {
        fontSize: 16,
        cursor: "pointer",
        marginLeft: 8,
        verticalAlign: "-6px"
      },
      onClick: () => handleDeleteSelected(item)
    }));
  })))))));
};
const ModalWrapper = styled.div`
  /* .product-content {
    display: flex;
  } */

  .product-img {
    display: inline-block;
    vertical-align: top;
    border: 1px solid #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
  }

  .product-info {
    display: inline-block;
    margin-left: 12px;
    vertical-align: top;
    /* width: calc(100% - 72px); */
    width: calc(100% - 78px);
  }

  .product-info-name {
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #606c80;
    line-height: 18px;
  }
`;
export default AddProductButtonAndModal;
